export default __webpack_public_path__ + "static/media/paid_invoice.1da8742a.webp";